"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Production Server (Make sure to uncomment this before pushing)
var BASE_URL = 'https://app.hellonext.co/api/v5';
// Staging Server
// const BASE_URL: string = 'https://app.desksetups.in/api/v5';
// Development Server
// const BASE_URL: string = 'http://app.lvh.me:3000/api/v5';
var GET_ORGANIZATION = BASE_URL + '/organizations/info';
exports.GET_ORGANIZATION = GET_ORGANIZATION;
var GET_CHANGELOGS = BASE_URL + "/changelogs";
exports.GET_CHANGELOGS = GET_CHANGELOGS;
var GET_CHANGELOG = function (changelogId) { return BASE_URL + "/changelogs/" + changelogId; };
exports.GET_CHANGELOG = GET_CHANGELOG;
